var render = function render(){var _vm=this,_c=_vm._self._c;return _c('a',{staticClass:"flex items-center",attrs:{"href":_vm.block.form.file.url,"target":"_blank"}},[_c('i',{staticClass:"fa fa-file fa-2x mr-2"}),_vm._v(" "),_c('div',[_vm._v(_vm._s(_vm.block.form.caption ? _vm.block.form.caption : _vm.block.form.file.url))])])
}
var staticRenderFns = []

export { render, staticRenderFns }